<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        md="8"
      >
        <b-card>
          <b-row>
            <b-col
              cols="12"
            >
              <title-text />
            </b-col>
            <b-col
              cols="12"
            >
              <phone-number />
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <whatsapp-number />
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <email-address />
            </b-col>
            <b-col
              cols="12"
            >
              <address-text />
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <menu-color />
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <menu-view />
            </b-col>
          </b-row>
        </b-card>
        <b-button
          variant="primary"
          :disabled="dataItem.submitStatus"
          @click="submitForm"
        >
          Kaydet
        </b-button>
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <logo-upload />
        <logo-upload2 />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BCard, BRow, BCol, BButton,
} from 'bootstrap-vue'
import TitleText from '@/views/Branches/Elements/TitleText.vue'
import PhoneNumber from '@/views/Branches/Elements/PhoneNumber.vue'
import EmailAddress from '@/views/Branches/Elements/EmailAddress.vue'
import WhatsappNumber from '@/views/Branches/Elements/WhatsappNumber.vue'
import AddressText from '@/views/Branches/Elements/AddressText.vue'
import MenuColor from '@/views/Branches/Elements/MenuColor.vue'
import MenuView from '@/views/Branches/Elements/MenuView.vue'
import LogoUpload from '@/views/Branches/Elements/LogoUpload.vue'
import LogoUpload2 from '@/views/Branches/Elements/LogoUpload2.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    TitleText,
    PhoneNumber,
    EmailAddress,
    WhatsappNumber,
    AddressText,
    MenuColor,
    MenuView,
    LogoUpload,
    LogoUpload2,
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      mediaType: 'image',
      cropperSettings: {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        type: null,
      },
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['branches/dataItem']
    },
  },
}
</script>
